import styled from 'styled-components';

/** Adicionar a estilização da página */
export const Container = styled.div`

`;
